import PropTypes from 'prop-types';

import Tooltip from '../../core/Tooltip';
import IconButton from '../../core/IconButton';
import { labelValuesStr } from '../utils/formatCharts/handleCustomValue';

import {
  Chain,
} from '../../icons';

import { StyledInsightWrapper, StyledKpiContentLabel } from './styled/Insight.styled';
import Markdown from '../../core/Markdown';

const getInsightStyle = (styles, globalConfig) => ({
  backgroundColor: globalConfig?.useGlobalTheme ? globalConfig.insightBg : styles?.bgColor,
  color: globalConfig?.useGlobalTheme ? globalConfig.insightTxt : styles?.fontColor ?? '#222',
  fontSize: `${styles?.fontSize ?? 16}px`,
  fontFamily: `'${globalConfig?.useGlobalFont ? globalConfig.fontInsight : (styles?.fontFamily?.value ?? styles?.fontFamily)}', Arial`,
  fontWeight: styles?.bold ? 'bold' : 'normal',
  textDecoration: styles?.underline ? 'underline' : 'none',
  fontStyle: styles?.italic ? 'italic' : 'normal',
  borderRadius: `${Number.isNaN(+globalConfig?.borderStyle?.rounded) ? '4' : globalConfig.borderStyle.rounded}px`,
});

const Insight = ({
  item, globalConfig = {},
}) => (
  <StyledKpiContentLabel
    style={getInsightStyle(item.style, globalConfig)}
    styles={item.style}
    img={item?.style?.image || ''}
  >
    <StyledInsightWrapper>
      <Markdown>
        {item.style.isNumeric ? labelValuesStr(item.name, null, item.style) : item.name}
      </Markdown>
    </StyledInsightWrapper>
    {item.link?.length > 0 && (
      <div style={{
        position: 'absolute', left: '4px', bottom: '4px', fontSize: 'initial',
      }}
      >
        <Tooltip direction="right" text={`Redirecionar para ${item.link}`}>
          <a href={item.link} target="_blank" rel="noopener noreferrer">
            <IconButton
              variant="outlined"
              size="small"
              shape="rounded"
              iconSize="18px"
              style={{ boxShadow: 'none' }}
            >
              <Chain />
            </IconButton>
          </a>
        </Tooltip>
      </div>
    )}
  </StyledKpiContentLabel>
);

Insight.propTypes = {
  item: PropTypes.shape({
    style: PropTypes.shape({
      image: PropTypes.string,
      isNumeric: PropTypes.bool,
    }),
    link: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  globalConfig: PropTypes.shape({}),
};

export default Insight;
